import {
  useState,
  useCallback,
  useRef,
} from 'react';
import {
  available_assignees_tickets_path as requestPath,
} from 'js-routes/generated/routes';
import debounceFetcher from 'helpers/debounceFetcher';

const useDebounceAssigneeUserFetch = ({ initialOptions }) => {
  const [searchValue, setSearchValue] = useState('');
  const [dataFetching, setDataFetching] = useState(false);
  const [assigneeUsers, setAssigneeUsers] = useState(initialOptions);
  const assigneeUserFetchRef = useRef(0);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(debounceFetcher({
    fetchRef: assigneeUserFetchRef,
    setOptions: setAssigneeUsers,
    setFetching: setDataFetching,
    requestPath,
    responseFormat: ({ data }) => data.assignee_users,
  }), []);

  const debouncedAssigneeUsersFetch = (searchText) => {
    setSearchValue(searchText);
    debouncedSearch(searchText);
  };

  return ({
    assigneeUserFetch: debouncedAssigneeUsersFetch,
    searchValue,
    dataFetching,
    assigneeUsers,
  });
};

export default useDebounceAssigneeUserFetch;
